const noop = () => undefined
const debug: any = {
    clickedCount: 0,
    vconsole: null,
    timer: null
}

function onDebugTitleClick() {
    if (debug.clickedCount === 0) {
        debug.timer = setTimeout(() => {
            debug.clickedCount = 0
        }, 5000)
    }
    debug.clickedCount++
    if (debug.clickedCount >= 10) {
        debug.clickedCount = 0
        clearTimeout(debug.timer)
        debug.timer = null
        // @ts-ignore
        const VConsole = window.VConsole
        if (!debug.vconsole) debug.vconsole = new VConsole()
        else {
            debug.vconsole.destroy()
            debug.vconsole = null
        }
    }
}

export default function applyVConsole() {
    // @ts-ignore
    const VConsole = window.VConsole
    if (!VConsole) return noop
    if (process.env.NODE_ENV === 'development' || window.location.href.includes('test-h5')) {
        new VConsole().setSwitchPosition(200, 200)
        return noop
    }
    document.addEventListener('click', onDebugTitleClick)
    return () => {
        document.removeEventListener('click', onDebugTitleClick)
    }
}